<web-widget-breadcrumbs [widget]="widget()" [isInSpecificSection]="isSpecific()"></web-widget-breadcrumbs>

<div class="panel-options-body overflow-wrapper">
    <web-paid-access-notification-container [widgetName]="widget().name"></web-paid-access-notification-container>

    <div class="form form-horizontal">
        <div
            class="mb-20"
            cdkDropList
            [cdkDropListData]="accordionList()"
            (cdkDropListDropped)="dropElementItem($event)"
        >
            <div
                cdkDrag
                cdkDropListGroup
                [cdkDragData]="accordionItem"
                *ngFor="let accordionItem of accordionList(); let i = index"
            >
                <sp-control-handle
                    [controlHandleBtn]="accordionList().length === 1 ? false : true"
                    [controlHandleDisableDelete]="accordionList().length === 1"
                    [controlHandleMainText]="accordionItem.title | spHtmlToText"
                    [controlHandleSubText]="accordionItem.content | spHtmlToText"
                    (editActionEvent)="setActiveItem(i)"
                    (removeActionEvent)="removeAccordion(i)"
                >
                </sp-control-handle>
            </div>

            <a class="dotted" (click)="addAccordion()">{{ "add" | translate }}</a>
        </div>

        <div class="form-row mb-20">
            <div class="form-group mb-20">
                <label class="col-xs-9 control-label">
                    {{ "control_auto_collapse" | translate }}
                </label>
                <div class="col-xs-3 text-right">
                    <sp-switch [active]="form.isAutoCollapse().value()" (toggleActiveEvent)="setIsAutoCollapse($event)">
                    </sp-switch>
                </div>
            </div>

            <div class="form-group mb-20">
                <label class="col-xs-12">
                    {{ "control_appearance" | translate }}
                </label>
                <div class="col-xs-5">
                    <sp-radio-group
                        [selected]="form.iconType().value()"
                        [type]="ERadioGroupType.faqIconStyle"
                        (changeSelectedEvent)="setIconType($event)"
                    ></sp-radio-group>
                </div>
                <div class="col-xs-5">
                    <sp-radio-group
                        [selected]="form.horizontalAlign().value()"
                        [type]="ERadioGroupType.faqIconPosition"
                        (changeSelectedEvent)="setHorizontalAlign($event)"
                    ></sp-radio-group>
                </div>
                <div class="col-xs-2">
                    <web-color-picker
                        [color]="form.iconColor().value()"
                        (colorChangeEvent)="setIconColor($event)"
                    ></web-color-picker>
                </div>
            </div>

            <div class="form-group mb-20">
                <label class="col-xs-9 control-label">
                    {{ "control_separator" | translate }}
                </label>
                <div class="col-xs-3 text-right">
                    <sp-switch [active]="form.isIndent().value()" (toggleActiveEvent)="setIsIndent($event)">
                    </sp-switch>
                </div>
            </div>

            <!-- Показываем если включен разделитель -->
            <div class="form-group mb-20" *ngIf="form.isIndent().value()">
                <label class="col-xs-9 control-label">
                    {{ "control_separator_color" | translate }}
                </label>
                <div class="col-xs-3 text-right">
                    <web-color-picker
                        [color]="form.indentColor().value()"
                        (colorChangeEvent)="setIndentColor($event)"
                    ></web-color-picker>
                </div>
            </div>
        </div>

        <div class="form-group mb-10">
            <div class="col-xs-12 device-toggle-wrapper">
                <web-device-toggle></web-device-toggle>

                <web-synchronize-style-toggle
                    [active]="form.isSynchronized()"
                    (click)="setSynchronizeStyle()"
                ></web-synchronize-style-toggle>
            </div>
        </div>

        <div class="form-group mb-0">
            <ng-container *ngIf="isDeviceDesktopSig()">
                <p class="col-xs-12 help-block text-muted small">
                    {{ "desktop_device_hint" | translate }}
                </p>
            </ng-container>

            <ng-container *ngIf="isDeviceTabletSig()">
                <p class="col-xs-12 help-block text-muted small">
                    {{ "tablet_device_hint" | translate }}
                </p>
            </ng-container>

            <ng-container *ngIf="isDeviceMobileSig()">
                <p class="col-xs-12 help-block text-muted small">
                    {{ "mobile_device_hint" | translate }}
                </p>
            </ng-container>
        </div>

        <web-widget-position-settings
            [isSynchronized]="form.isSynchronized()"
            [isTablet]="isDeviceTabletSig()"
            [isMobile]="isDeviceMobileSig()"
            [widgetId]="widget().id"
            [columnId]="widget().columnId"
            [position]="position()"
            (positionChange)="onPositionChange($any($event))"
        ></web-widget-position-settings>

        <div class="form-group mb-0">
            <div class="col-xs-12">
                <hr class="panel-options-divider" />
            </div>
        </div>

        <web-widget-hide-settings
            [hideOnDesktop]="form.hideOnDesktop().value()"
            [hideOnTablet]="form.hideOnTablet().value()"
            [hideOnMobile]="form.hideOnMobile().value()"
            (hideOnDesktopChange)="setHideOnDesktop($event)"
            (hideOnTabletChange)="setHideOnTablet($event)"
            (hideOnMobileChange)="setHideOnMobile($event)"
        ></web-widget-hide-settings>

        <div class="form-group mb-0">
            <div class="col-xs-12">
                <hr class="panel-options-divider" />
            </div>
        </div>

        <div class="mt-20">
            <web-custom-id [displayId]="form.displayId()" (valueChangeEvent)="form.setDisplayId($event)">
            </web-custom-id>
        </div>
    </div>
</div>
